import { render, staticRenderFns } from "./WhatsAppSetting.vue?vue&type=template&id=0fefacaa&"
import script from "./WhatsAppSetting.vue?vue&type=script&lang=js&"
export * from "./WhatsAppSetting.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports